import { Box } from "@mui/material";

const LicenseInfo = () => {
  return (
    <Box
      width="100%"
      minHeight="40px" // Minimum height for visibility
      bgcolor="black"
      sx={{
        position: "fixed",
        left: 0,
        bottom: 0,
        display: "flex",
        flexWrap: "wrap", // Allow content to wrap if needed
        justifyContent: "space-between",
        alignItems: "center",
        padding: { xs: "8px 4%", sm: "8px 10%" }, // Responsive padding
        color: "white",
        zIndex: 1300,
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ wordBreak: "break-word" }}>Emduben Construction Services LLC</Box>
      <Box sx={{ wordBreak: "break-word" }}>License Number: BC808013</Box>
    </Box>
  );
};

export default LicenseInfo;
